module.exports = __webpack_public_path__ + "assets/img/LTC026.481423d8.png";